import { MIN_WIDTH } from '../config/designSystem/MinWidth';
import { useWindowDimensions } from 'react-native';

export const useBreakpoint = () => {
  const {width} = useWindowDimensions();
  if (width > MIN_WIDTH.lg) {
    return {xl: true};
  } else if (width > MIN_WIDTH.md) {
    return {lg: true};
  } else if (width > MIN_WIDTH.sm) {
    return {md: true};
  } else {
    return {sm: true};
  }
};